import React, {useState, useEffect, useRef} from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  DatePicker,
  Upload,
  notification,
  Card,
  Space,
  Divider, Switch, Tooltip, Modal,
} from "antd";
import {PlusOutlined, DownloadOutlined, UploadOutlined, CopyOutlined, InfoCircleOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import CurrencyInput from 'react-currency-input';
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import config from "../../util/ApiforContext";
import moment from 'moment';
import Text from "antd/lib/typography/Text";
import requestHandler from "../../util/RequestHandler";

const HIGH_AMOUNT_THRESHOLD = 10000000;
const TRY_CURRENCY_ID = 1;

const parseAmount = (v) => {
  if (v == null || v === '') return 0;
  if (typeof v === 'number') return v;
  return parseFloat(String(v).replace(/\./g, '').replace(',', '.')) || 0;
};

const isHighTryAmount = (amount, currencyId) =>
  currencyId === TRY_CURRENCY_ID && parseAmount(amount) > HIGH_AMOUNT_THRESHOLD;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TosPaymentAddForm = (props) => {
  const { confirm } = Modal;

  const userId = localStorage.getItem("userId");
  const tenantId = localStorage.getItem("tenantId");
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [bankId, setbankId] = useState("");
  const [bankBranchName, setbankBranchName] = useState("");
  const [iban, setIban] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [firmName, setFirmName] = useState("");
  const [title, setTitle] = useState("");
  const [bankBranchId, setBankBranchId] = useState("");
  const [accountNumberFromFirmAccount, setAccountNumberFromFirmAccount] = useState("");
  const [ibanFromFirmAccount, setIbanFromFirmAccount] = useState("");
  const [bankDropdown, setbankDropdown] = useState([]);
  const [firmDropdown, setfirmDropdown] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [vknOrTckn, setVknOrTckn] = useState("");

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: true,
  });

  const [currencyId, setCurrencyId] = useState(1);

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [isDisableCurrencySelect, setIsDisableCurrencySelect] = useState(false);
  const [form] = Form.useForm();

  const [firmIbans, setFirmIbans] = useState([]);

  const [hasUsePdf, setHasUsePdf] = useState(false);

  const [swiftCode, setSwiftCode] = useState("");
  const [referenceCode, setReferenceCode] = useState("");
  const [isSendTosVirmanUnApproved, setIsSendTosVirmanUnApproved] = useState(false);
  const [activeSendTosVirman, setActiveSendTosVirman] = useState(false);
  const [firmAccounts, setFirmAccounts] = useState([]);
  const [tenantPaymentAccounts, setTenantPaymentAccounts] = useState({
    data:[]
  });
  const [defaultValue, setDefaultValue] = useState("");
  const [bankUSeWebService, setBankUSeWebService] = useState(false);
  const [bankUsePdf, setBankUsePdf] = useState(false);
  const today = moment().format('DD.MM.YYYY');
  const [clickSendBankButton, setClickSendBankButton] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);

  const [showRetryButton, setShowRetryButton] = useState(false);
  const [startInterval, setStartInterval] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [seconds, setSeconds] = useState(180);

  const [activeTosSms, setActiveTosSms] = useState(false);

  const [checkSameEntity, setCheckSameEntity] = useState(true);

  const ref = useRef();
  const intervalRef = useRef(null);

  const [directive, setDirective] = useState({});

  const [paymentTypes, setPaymentTypes] = useState([]);

  useEffect(() => {
    checkTosRoles();
    getCurrencies();

    RequestHandler.get(
      `/TosBankInfo?$filter=isUsePdf eq true`
    ).then((response) => {
     setHasUsePdf(response.value.length > 0);
    });

    RequestHandler.get("/TenantParameter/GetByTenant").then(response => {
      setActiveTosSms(response.tosSmsOtp);
    });

    RequestHandler.get("/Payment/PaymentTypes?isSwiftTransfer=false").then((data) => {
      setPaymentTypes(Array.isArray(data) ? data : []);
    }).catch(() => setPaymentTypes([]));

  }, []);


  useEffect(() => {
    if(activeSendTosVirman) {
      getFirmAccounts();
    }
  }, [activeSendTosVirman]);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (showOtpModal) {
      setSeconds(180);

      intervalRef.current =  setInterval(() => {

        setSeconds((prev) => {

          let second = prev - 1;

          if(second === 0) {
            clearInterval(intervalRef.current);
            setShowRetryButton(true);

            return 0;
          }

          return second;
        });
      }, 1000)
    }
    else {

      clearInterval(intervalRef.current);
    }
  }, [showOtpModal, startInterval])

  const checkTosRoles = () => {
    RequestHandler.get(`/TosAuthorize/CheckTosVirmanUnApproved/${userId}`).then((response) => {
      setIsSendTosVirmanUnApproved(response.data);

    });
  }

  const getFirmAccounts = () => {
    RequestHandler.get(`/FirmAccount?$filter=isTosVirmanAccount eq true`).then((response) => {
       setFirmAccounts(response.value);
    });
  }

  const onChangeFirmAccount = (value) => {

    const firmAccount = firmAccounts.filter(x => x.id === value);

    if(firmAccount.length > 0) {
      const account = firmAccount[0];

      RequestHandler.get(`/bankbranch/getbranchforbank?id=${account.bankId}`).then((response) => {
        setbankBranchDropdown(response)
      });

      RequestHandler.get(`/Tenant/GetById/${tenantId}`).then((res) => {
        setTitle(res?.name)
        setVknOrTckn(res?.vkn);
      });

      RequestHandler.get(`/TenantPaymentAccount?$filter=currencyId eq ${account.currencyId}`).then((response) => {

        const defaultValue = response.value.filter(x => x.isDefault);

        if(defaultValue.length > 0) {
          setDefaultValue(defaultValue[0].id);

          setBankUSeWebService(defaultValue[0].isUseWebService);

          if(defaultValue[0].isUseWebService) {
            form.setFieldsValue({"paymentDate": moment() })
          }
        }

        setTenantPaymentAccounts({
          data: response.value,
          loading: false,
        });
      });

      setBankBranchId(account.bankBranchId)
      setbankId(account.bankId)
      setAccountNumber(account.accountNumber);
      setIban(account.iban);
      setAccountNumberFromFirmAccount(account.accountNumber);
      setIbanFromFirmAccount(account.iban);
      setCurrencyId(account.currencyId);
    }
  }

  const handleTenantPaymentAccounts = (value) => {
    setDefaultValue(value);

    let bank = tenantPaymentAccounts.data.find(x => x.id === value);

    if(bank) {
      if(bank.isUseWebService) {
        form.setFieldsValue({"paymentDate": moment() })
      }

      setBankUSeWebService(bank.isUseWebService);
      setBankUsePdf(bank.isUsePdf);
    }
  }

  const onOtpConfirm = () => {
    ref.current.submit();
  }

  const handleCancelOtpModal = () => {
    setShowOtpModal(false)
    setStartInterval(false);
    setShowRetryButton(false);
  };

  const otpFormFinish = (values) => {
    setConfirmLoading(true);
    clearInterval(intervalRef)


    RequestHandler.post(
      `/Directive/VerifyOtp?otpCode=${values.otp}&directiveId=${directive.id}`,
      true
    ).then((res) => {
      if(res.success){
        setShowOtpModal(false);
        setConfirmLoading(false);
        setShowRetryButton(false);
        successDirective(directive.id, directive.directiveNumber);
      }else{
        setConfirmLoading(false);
      }
    });
  }


  const onChangeOtpValue = (e) => {
    setErrorText("")
    setOtpInput(e.target.value)
  }

  const successDirective = (directiveId, directiveNumber) => {
    let message= '';
    var falseList= [];
    var trueList = [];
    RequestHandler.post(
      "/Directive/SendBankOrConfirm",
      {
        directiveIds: [directiveId]
      },
      false
    ).then((res) => {
      if(res.success){

        res.data.map((item) => {
          if(item == true){
            trueList.push(true);
          }else{
            falseList.push(false);
          }
        })
        let sendMessage = trueList.length > 0 ? 'bankaya' : 'onaya';
        sendMessage = trueList.length > 0 && falseList.length > 0 ? 'onaya ve bankaya' : sendMessage;

        message = directiveNumber + ' numaralı talimatınız başarı ile ' + sendMessage + ' gönderildi.';

        Modal.success({
          content: message,
          onOk: onOk
        });
      }
    });
  }

  function onOk() {
    window.location.reload();
  }

  const sendOtp = () => {
    RequestHandler.post(
      `/Directive/ResendOtp?directiveId=${directive.id}`,
      true
    ).then((res) => {
      setStartInterval(true);
      setShowRetryButton(false);
    });
  }

  const maxLengthCheck = (object) => {
    if (object.target.value?.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const getCurrencies = () => {
    setIban('TR')
    setCurrencySelect({
      ...bankSelect,
      loading: true,
    });

    RequestHandler.get("/Payment/CurrencyList").then((response) => {
      setCurrencySelect({
        data: response.data,
        loading: false,
      });
    });

    RequestHandler.get(`/bank?$filter=isEmoney ne true&$orderby=name`).then((response) => {
      const bankDropdown = response.value.filter(x => x.id !== 999);
      setbankDropdown(bankDropdown)
    });
  };

  const onFinish = (values) => {
    values.paymentDate = values.paymentDate.format("YYYY-MM-DD HH:mm:ss");
    values.AmountString = values.amount;
    values.amount = 1;
    values.isFromWeb = true;

    if (values.description) {
      values.description = values.description.trimEnd();
    }

    if(values.valueDate) {
      values.valueDate = values.valueDate.format("YYYY-MM-DD");
    }

    let url = '/Payment';

    if(clickSendBankButton) {
      url = "/Directive/AddPaymentAndSendToBank";
    }

    values.checkSamePayment = checkSameEntity;

    RequestHandler.post(url, values, !activeTosSms && !checkSameEntity).then((response) => {
      setLoading(false);
      if (response.success) {

        if(response.data == null) {
          showConfirm(true);
        }
        else {
           if(clickSendBankButton) {
             setDirective(response.data);
             if(activeTosSms && response.data.otpCode != null) {
              setShowOtpModal(true)
             }
             else {
               successDirective(response.data.id, response.data.directiveNumber);
             }
           }
           else {

             form.resetFields();
             setTitle('')
             setbankId('')
             setIban('TR')
             setFirmIbans([]);
             setCheckSameEntity(true);
          }

          if (props.onSuccess) props.onSuccess();
        }
      }
    });
  };

  const showConfirm = (values) => {
    setLoading(true);
    confirm({
      title: 'Aynı ödeme mevcut!',
      icon: <ExclamationCircleOutlined />,
      content: 'Aynı tutar ve tarihli ödemeyi daha önce eklediniz yine de devam etmek istiyor musunuz?',
      cancelText: 'Hayır',
      okText:'Evet',
      onOk() {
        setCheckSameEntity(false);
        form.submit();
      },
      onCancel() {
        setLoading(false);

      },
    });
  }

  const onChange = (value) => {
    RequestHandler.get(`/bankbranch/getbranchforbank?id=${value}`).then((response) => {
      setbankBranchDropdown(response)
      setbankId(value)
      setbankBranchName('')
    });
  }

  const onChangeCurrencyId = (value) => {
    setCurrencyId(value);
  }


  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };
  const onChangeIban = (value) => {
    changeIban(value.target.value);
  };

  const changeIban = (iban) => {
    const bankCode = iban
      .toUpperCase()
      .replace(/\s+/g, "")
      .substring(5, 9);

    const bank = bankDropdown.filter((x) => x.code == bankCode);

    if (bank.length > 0) {
      setbankId(bank[0].id);
    }

    setIban(iban);
  }

  const onChangeTitle = (value) => {
    setTitle(value.target.value);
  }
  const onChangeAmount = (value) => {
    setTitle(value.target.value.replace(',', '.'));
  }
  function disabledDate(current) {
    return moment().add(-1, 'days') >= current
  }
  const onSearch = (val) => {
    if (val.length >= 3) {
      RequestHandler.get(`/Firm?isFilter=true&$filter=contains(name, '${val}') or contains(firmBranchNumber, '${val}') `).then((response) => {
        const firmDropdown = response.value;
        setfirmDropdown(firmDropdown)
      });
    } else {
      const firmDropdown = [];
      setfirmDropdown(firmDropdown)
    }
  }
  const onFocus = () => {
    RequestHandler.get(`/Firm?$filter=contains(name, '___')`).then((response) => {
      const firmDropdown = response.value;
      setfirmDropdown(firmDropdown)
    });
  }

  const onChangeVknOrTckn = (value) => {
    setVknOrTckn(value.target.value);
  }

  const onChangeFirm = (val) => {

    setCurrencyId(1);
    setIsDisableCurrencySelect(false);

    RequestHandler.get(`/FirmAccount?$filter= firmId eq ${val} and iban ne null and iban ne ''`).then((res) => {


      let defaultAccount = res.value.filter(x=> x.isDefault);

      if(defaultAccount.length > 0) {
        RequestHandler.get(`/bankbranch/getbranchforbank?id=${defaultAccount[0].bankId}`).then((response) => {
          setbankBranchDropdown(response)
        });

      }
      else {
        setbankBranchDropdown(null)
      }

      setBankBranchId(defaultAccount[0]?.bankBranchId)
      setbankId(defaultAccount[0]?.bankId)
      setAccountNumber(defaultAccount[0]?.accountNumber)
      setIban(defaultAccount[0]?.iban)
      setAccountNumberFromFirmAccount(defaultAccount[0]?.accountNumber)
      setIbanFromFirmAccount(defaultAccount[0]?.iban)


      setTitle(res?.value[0]?.firmName)
      setFirmIbans(res.value);
    });
  }
  const downloadExcelTemplate = () => {
    window.open(
      `${config.apiUrl
      }/Payment/DownloadExcelTemplate?t=${RequestHandler.getToken()}`
    );
  };
  const onChangeAccountNumber = (value) => {
    setAccountNumber(value.target.value);
  }
  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/Payment/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };
  const onSuccess = () => {
    form.resetFields();
    setFileList([]);

    if (props.onSuccess) props.onSuccess();
  };
  const downloadImportResult = (fileName) => {
    window.open(
      `${config.apiUrl
      }/Payment/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const selectFirmIban = (value) => {

    let currency = firmIbans.filter(x=> x.iban === value);

    if(currency.length > 0) {

      if(currency[0].currency !== "-") {
        setCurrencyId(currency[0].currencyId);

        setIsDisableCurrencySelect(true);
      }
      else {
        setCurrencyId(1);

        setIsDisableCurrencySelect(false);
      }

    }


    setIban(value);
    changeIban(value);
  }

  const onChangeSwiftCode = (value) => {
    setSwiftCode(value);
  }

  const onChangeReferenceCode = (value) => {
    setReferenceCode(value);
  }


  const handlePaste = (e) => {
    e.preventDefault();
    let text = e.clipboardData.getData("text");

    text = text.replace(/\s+/g, "");
    changeIban(text);

  };


  const { Option } = Select;
  return (
    <>
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="tosPaymentAdd"
      initialValues={{
        remember: true,
      }}
      fields={[
        { name: "title", value: title },
        { name: "bankId", value: bankId },
        { name: "BankBranchId", value: bankBranchId },
        { name: "accountNumber", value: accountNumber },
        { name: "iban", value: iban },
        { name: "currencyId", value: currencyId },
        { name: "vknOrTckn", value:vknOrTckn }
      ]}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        {
          isSendTosVirmanUnApproved ?
            <>
              <Col span={24}>
                <Form.Item label="Şirket Hesabına Gönder" name="isSendVirman">
                   <Switch onChange={(val) => {
                     setActiveSendTosVirman(val);
                   }}/>
                </Form.Item>



              {
                activeSendTosVirman ?
                  <>

                      <Form.Item label="Şirket Hesabı" name="accounts"
                         dependencies={['sendFirmAccount']}
                         rules={[
                           ({ getFieldValue }) => ({
                             validator(_, value) {
                               if (getFieldValue('sendFirmAccount')) {
                                 if (!value || value.length === 0) {
                                   return Promise.reject('Şirket Hesabı seçimi zorunludur');
                                 }
                               }
                               return Promise.resolve();
                             }
                           })
                         ]}
                      >
                        <Select
                          showSearch
                          placeholder="En az 3 harf giriniz.."
                          optionFilterProp="children"
                          onChange={onChangeFirmAccount}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLocaleLowerCase("tr-TR")
                              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                          }
                         >
                          {firmAccounts.map(item => (
                            <Option key={item.id} value={item.id}>{item.iban}</Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name="tenantPaymentAccountId"
                        label= "Gönderen Banka Kodu"
                      >
                        <Select
                          allowClear
                          showSearch
                          placeholder="Seçiniz"
                          onChange={handleTenantPaymentAccounts}
                          value={defaultValue === "" ? null : defaultValue}
                          filterOption={(input, option) =>
                            option.children[0]
                              .toLocaleLowerCase("tr-TR")
                              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                          }
                        >
                          {tenantPaymentAccounts.data.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name} - {item.iban}
                            </Select.Option>
                          ))}

                          {bankUsePdf ? <span style={{ color: 'red' }}>Bağlantı tipinize göre talimatınız bankaya gönderilmemektedir.</span> : ""}
                        </Select>
                      </Form.Item>
                  </> :
                  <></>

              }
              </Col>

           </> : <></>
        }

        <Col span={24}>
          <Form.Item
            label="Cari Adı/Ünvanı"
            name="FirmId"
            hidden={activeSendTosVirman}
          >
            <Select
              showSearch
              placeholder="En az 3 harf giriniz.."
              optionFilterProp="children"
              onFocus={onFocus}
              onSearch={onSearch}
              onChange={onChangeFirm}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmDropdown.map(item => (
                <Option key={item.id}>{`${item.name} (${item.firmBranchNumber})`}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Ad Soyad / Ünvan"
            name="title"
            rules={[{ required: true }]}
          >
            <Input value={title} onChange={onChangeTitle} disabled={activeSendTosVirman} />
          </Form.Item>

          <Form.Item
            label="Tckn/Vkn"
            name="vknOrTckn"
            dependencies={["amount", "currencyId"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const amount = getFieldValue("amount");
                  const currencyId = getFieldValue("currencyId");
                  if (isHighTryAmount(amount, currencyId) && (!value || String(value).trim() === "")) {
                    return Promise.reject("10.000.000 TRY üzeri ödemelerde VKN/TCKN alanı zorunludur.");
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input value={vknOrTckn} onChange={onChangeVknOrTckn} disabled={activeSendTosVirman} />
          </Form.Item>

          <Form.Item
            label="Alıcı Banka"
            name="bankId"
            rules={[
              {
                required: true,
                message: 'Lütfen banka alanını boş bırakmayın.',
              },
            ]}
          >
            <Select
              showSearch
              placeholder="Seçiniz."
              optionFilterProp="children"
              onChange={onChange}
              disabled={activeSendTosVirman}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankDropdown.map(item => (
                item.name === "KASA HESABI" ? "" :
                  <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          {firmIbans.length > 0 ? <>
                        <Form.Item label="Kayıtlı İbanlar">
             <Select
              showSearch
              placeholder="Seçiniz."
              optionFilterProp="children"
              onChange={selectFirmIban}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmIbans.map(item => (
                <Option key={item.iban} value={item.iban} currencyId={item.currencyId}>{item.title ? `${item.title} - ` : ''}{item.iban} - {item.currency} - {item.bankName}</Option>
              ))}
            </Select>
          </Form.Item>
          </> : <></>}


          <Form.Item
            label="Alıcı IBAN"
            name="iban"
            onChange={onChangeIban}
            onPaste={handlePaste}
            rules={
              [
                {
                  required: true,
                  message: 'Lütfen Iban alanını boş bırakmayın.',
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const cleaned = value.replace(/\s+/g, "").toUpperCase();
                    if (cleaned.length !== 26) return Promise.reject('IBAN 26 karakter olmalıdır.');
                    if (!/^TR\d{2}[A-Z0-9]{22}$/.test(cleaned)) return Promise.reject('IBAN formatı geçersiz. TR ile başlamalı ve ardından 24 alfanumerik karakter gelmelidir.');
                    return Promise.resolve();
                  }
                },
              ]}
          >
            <Input type="text" onFocus={(event) => { event.target.select() }} maxLength="26" disabled={activeSendTosVirman} />
          </Form.Item>



          <Form.Item label="Tutar" name="amount" rules={[{ required: true }]}>
            <CurrencyInput style={{ width: "100%" }} className="ant-input" decimalSeparator="," thousandSeparator="." />
            {/* <InputNumber min={0} style={{width:'100%'}} parser={value => value.replace(',', '.')} /> */}
          </Form.Item>

          <Form.Item
            name="currencyId"
            label="Para Birimi"
             rules={[{ required: true }]}

          >
            <Select
              allowClear
              showSearch
              defaultValue={1}
              value={1}
              onChange={onChangeCurrencyId}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
               disabled={isDisableCurrencySelect || activeSendTosVirman}
            >
               {currencySelect.data.map(({ id, code }) => (
                    <Select.Option key={id} value={id}>
                      {code}
                    </Select.Option>
                ))}

            </Select>
          </Form.Item>

          {bankUSeWebService ?
            <>

              <Form.Item
                label="Ödeme Tarihi"
                name="paymentDate"
              >
                {today} <Tooltip title="Web servis kullanımında yalnızca bugün tarihli ödemeler çıkmaktadır." ><InfoCircleOutlined /></Tooltip>
              </Form.Item>
            </> :
            <>
              <Form.Item
                label="Ödeme Tarihi"
                name="paymentDate"
                rules={[{ required: true }]}
              >
                <DatePicker disabledDate={disabledDate} format="DD.MM.YYYY" />
              </Form.Item>
            </>}

          <Form.Item label="İşlem tipi" name="paymentTypeId">
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              optionFilterProp="children"
            >
              {paymentTypes.map((pt) => (
                <Option key={pt.id} value={pt.id}>{pt.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Açıklama"
            name="description"
            dependencies={["amount", "currencyId"]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const amount = getFieldValue("amount");
                  const currencyId = getFieldValue("currencyId");
                  if (isHighTryAmount(amount, currencyId) && (!value || String(value).trim() === "")) {
                    return Promise.reject("10.000.000 TRY üzeri ödemelerde Açıklama alanı zorunludur.");
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>

          {
            hasUsePdf && currencyId !== 1 ? <>
                <Form.Item
                  label="Swift Kodu"
                  name="swiftCode"
                >
                  <Input value={swiftCode} onChange={onChangeSwiftCode} />
                </Form.Item>

                <Form.Item
                  label="Referans Kodu"
                  name="referenceCode"
                >
                  <Input value={referenceCode} onChange={onChangeReferenceCode} />
                </Form.Item>

                <Form.Item
                  label="Valör Tarihi"
                  name="valueDate"
                >
                  <DatePicker format="DD.MM.YYYY" />
                </Form.Item>

              </> :
              <></>
          }

          <Col style={{ textAlign: "right" }}>
            <Button
              icon={<DownloadOutlined />}
              onClick={(() => setLoadingExcel(true), downloadExcelTemplate)}
              loading={loadingExcel}
            >
              Excel Şablonu İndir
            </Button>
            <Upload {...uploadExcelProps} fileList={fileList}>
              <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
            </Upload>

            {
              activeSendTosVirman ?
                <>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => { setLoading(true); setClickSendBankButton(true); }}
                    loading={loading}
                  >
                    Ekle ve Bankaya Gönder
                  </Button>
               </> : <></>
            }

            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>


      <Modal maskClosable={false} visible={showOtpModal} onOk={onOtpConfirm} okText="Onayla" keyboard={false} cancelText="İptal" onCancel={handleCancelOtpModal} confirmLoading={confirmLoading}>
        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>

        <Form
          onFinish={otpFormFinish}
          fields={[
            { name: "otp", value: otpInput },
          ]}
          ref={ref}
        >
          <Form.Item
            name="otp"
          >
            <Input onChange={onChangeOtpValue} type='text' maxLength={6}
                   autoComplete="off"
                   style={{ marginTop: 40 }} onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
              if (event.key === "Enter") {
                ref.current.submit();
              }
            }} />


          </Form.Item>
          <Row style={{ marginBottom: -25 }}>
            <Col span={17}></Col>
            <Col span={7}>
              {
                showRetryButton ? <>
                  <Button onClick={sendOtp}>
                    Tekrar Gönder
                  </Button>
                </> : <></>
              }

            </Col>
          </Row>
        </Form>
        <p style={{ color: 'darkred', textAlign: 'center', fontWeight: 600 }}>{errorText}</p>
      </Modal>
    </>
  );
};
export default TosPaymentAddForm;
